"use client";
import React, { FC } from "react";

import Sidebar from "@/components/layout/sidebar/sidebar";
import Header from "@/components/layout/header/header";
import { MapProvider } from "@/context/Map.context";
import { CourierProvider } from "@/context/Courier.context";
import { ParcelsProvider } from "@/context/Parcels.context";

type TProps = {
  children: React.ReactNode;
};

const ProtectedPagesLayout: FC<TProps> = ({ children }) => {
  return (
    <ParcelsProvider>
      <MapProvider>
        <CourierProvider>
          <main className="flex min-h-screen w-full justify-center">
            <div className="flex w-full justify-end">
              <Sidebar />
              <div className="z-20 h-screen w-full overflow-y-scroll rounded-bl-[32px] rounded-tl-[32px] bg-stone-50 px-6 lg:w-[82%] 2xl:px-10">
                <div>
                  <Header />
                  <div className="h-full pb-10 pt-[140px]">{children}</div>
                </div>
              </div>
            </div>
          </main>
        </CourierProvider>
      </MapProvider>
    </ParcelsProvider>
  );
};

export default ProtectedPagesLayout;
